import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_MONITORING_CREATE,
    ACTION_MONITORING_LOAD,
    ACTION_MONITORING_LOAD_BY_ID,

    ACTION_MONITORING_SAVE,
    ACTION_MONITORING_VALIDATE,
    ACTION_MONITORINGS_LOAD_BY_TRIALINSTITUTION_ID,
    CreateFailure,
    CreateSuccess,
    IMonitoringCreateAction,
    IMonitoringCreateFailureAction,
    IMonitoringCreateSuccessAction,
    IMonitoringLoadAction,
    IMonitoringLoadByIdAction,
    IMonitoringLoadFailureAction,
    IMonitoringLoadSuccessAction,

    IMonitoringSaveAction,
    IMonitoringSaveFailureAction,
    IMonitoringSaveSuccessAction,
    IMonitoringValidateAction,
    IMonitoringValidateFailureAction,
    IMonitoringValidateSuccessAction,
    IMonitoringsLoadByTrialInstitutionIdAction,
    LoadFailure,
    LoadSuccess,
    SaveFailure,
    SaveSuccess,
    ValidateFailure,
    ValidateSuccess,
} from "../actions/monitoring";
import { monitoringsApi } from "../services/monitorings";

export const
    getMonitoringsEpic = (action$): Observable<IMonitoringLoadSuccessAction | IMonitoringLoadFailureAction> => {
        return action$
            .ofType(ACTION_MONITORING_LOAD)
            .mergeMap((_action: IMonitoringLoadAction) => {
                return monitoringsApi
                    .getMonitorings()
                    .map(response =>
                        LoadSuccess(response.monitorings, undefined, [], response.lookups, undefined)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getMonitoringsByTrialInstitutionIdEpic = (action$): Observable<IMonitoringLoadSuccessAction | IMonitoringLoadFailureAction> => {
        return action$
            .ofType(ACTION_MONITORINGS_LOAD_BY_TRIALINSTITUTION_ID)
            .mergeMap((action: IMonitoringsLoadByTrialInstitutionIdAction) => {
                return monitoringsApi
                    .getMonitoringsByTrialInstitutionId(action.trialInstitutionId)
                    .map(response =>
                        LoadSuccess(response.monitorings, null, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getMonitoringsByIdEpic = (action$): Observable<IMonitoringLoadSuccessAction | IMonitoringLoadFailureAction> => {
        return action$
            .ofType(ACTION_MONITORING_LOAD_BY_ID)
            .mergeMap((action: IMonitoringLoadByIdAction) => {
                return monitoringsApi
                    .getMonitoringById(action.id)
                    .map(response =>
                        LoadSuccess(response.monitoring, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setMonitoringEpic = (action$): Observable<IMonitoringSaveSuccessAction | IMonitoringSaveFailureAction> => {
        return action$
            .ofType(ACTION_MONITORING_SAVE)
            .mergeMap((action: IMonitoringSaveAction) => {
                return monitoringsApi
                    .setMonitoring(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.monitoring, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createMonitoringEpic = (action$): Observable<IMonitoringCreateSuccessAction | IMonitoringCreateFailureAction> => {
        return action$
            .ofType(ACTION_MONITORING_CREATE)
            .mergeMap((action: IMonitoringCreateAction) => {
                return monitoringsApi
                    .createMonitoring(action.trialInstitutionId)
                    .map(response =>
                        CreateSuccess(response.monitoring, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateMonitoringEpic = (action$): Observable<IMonitoringValidateSuccessAction | IMonitoringValidateFailureAction> => {
        return action$
            .ofType(ACTION_MONITORING_VALIDATE)
            .mergeMap((action: IMonitoringValidateAction) => {
                return monitoringsApi
                    .validateMonitoring(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.monitoring, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }